let singletons = {

}

export default singletons



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/singletons.js